module.exports = __webpack_public_path__ + "media/images/entrance-eda1781ad5f5020b2497f9ea49350d2b.png";